export let UserAttributeKeys;

(function (UserAttributeKeys) {
  UserAttributeKeys["PREAPPLIED_FILTER_CHANGED"] = "Academy:LanguageFilter:preappliedFilterChanged";
  UserAttributeKeys["DONT_SHOW_AGAIN"] = "Academy:LanguageFilter:dontShowAgain";
  UserAttributeKeys["HAS_SEEN_CLOSE_TOOLTIP"] = "Academy:SoftwareDesirability:hasSeenCloseTooltip";
  UserAttributeKeys["HAS_VIEWED_PLAYLIST"] = "Academy:Playlists:hasViewedPlaylist";
  UserAttributeKeys["WIZARD_DONT_SHOW_AGAIN"] = "Academy:Wizard:dontShowAgain";
  UserAttributeKeys["WIZARD_RESULTS"] = "Academy:Wizard:wizardResults";
  UserAttributeKeys["WIZARD_COMPLETION_DATE"] = "Academy:Wizard:completionDate";
})(UserAttributeKeys || (UserAttributeKeys = {}));